import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';


const LANGUAGES = [
  { code: 'ua', label: 'УКР' },
  { code: 'en', label: 'ENG' },
  { code: 'pl', label: 'POL' },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    i18n.changeLanguage(selectedLanguage);
  };

  const currentLanguage = i18n.language?.substring(0, 2) || 'ua';

  return (
    <div className="language-switcher-container">
      <select 
        value={currentLanguage} 
        onChange={handleLanguageChange}
        className="language-select"
        aria-label="Select language"
      >
        {LANGUAGES.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;